export const checkoutCtaTrackProps = {
  class: 'annual-pass',
  location: 'footer',
}
